export function shop() {
  const shops = document.querySelectorAll('.js-shop');

  shops.forEach(shop => {
    const btn = shop.querySelector('.js-shopBtn');

    btn.addEventListener('click', () => {
      // is-active は別ファイルで切り替わる前提
      // → setTimeoutでDOM反映を少し待ってから判定する
      setTimeout(() => {
        const header = document.querySelector('#header');
        const header_h = header ? header.offsetHeight : 0;

        if (btn.classList.contains('is-active')) {
          btn.textContent = '閉じる';
        } else {
          btn.textContent = 'もっと見る';
        }

        const shop_top = shop.getBoundingClientRect().top + window.pageYOffset;

        window.scrollTo({
          top: shop_top - header_h,
        });
      }, 0);
    });
  });
}